module.exports = __webpack_public_path__ + "img/3d-avatar.8a0ca2dc.svg";